module.exports = __webpack_public_path__ + "static/media/no-image.b0f6378f.svg";